import { Grid } from '@material-ui/core';
import Loading from 'components/Loading';
import React from 'react';

export const TEST_CONNECTION_STORAGE_KEY = 'autosky@testConnection';

export default function SimulateApp() {
  const storage = localStorage.getItem(TEST_CONNECTION_STORAGE_KEY);

  React.useEffect(() => {
    if (storage) {
      const { parameters } = JSON.parse(storage);

      setTimeout(() => {
        window.name = parameters.window_name;
        window.location.href = `http://${parameters.instance}:${parameters.webport}/software/html5.html`;
      }, 2000);
    }
  }, [storage]);

  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      style={{ height: '90%' }}
    >
      <Loading />
    </Grid>
  );
}
